/** Salon contact — E.164 without + for wa.me */
export const SALON_PHONE_E164 = "48574516116";
export const SALON_PHONE_DISPLAY = "+48 574 516 116";
export const SALON_PHONE_TEL = `tel:+${SALON_PHONE_E164}`;
export const SALON_TELEGRAM_USERNAME = "bestgroomstudio";

export type QuickMessageChannel = "sms" | "whatsapp" | "telegram";

export function getTelegramWebHref (message: string): string {
  return `https://t.me/${SALON_TELEGRAM_USERNAME}?text=${encodeURIComponent(message)}`;
}

/** SMS, WhatsApp, and Telegram open with a prefilled intro in the UI language. */
export function getQuickMessageHref (
  channel: QuickMessageChannel,
  message: string
): string {
  const encoded = encodeURIComponent(message);

  switch (channel) {
    case "sms":
      // ?body= works on modern iOS and Android
      return `sms:+${SALON_PHONE_E164}?body=${encoded}`;
    case "whatsapp":
      return `https://wa.me/${SALON_PHONE_E164}?text=${encoded}`;
    case "telegram":
      // Deep link opens the Telegram app; https://t.me shows a web interstitial first
      return `tg://resolve?domain=${SALON_TELEGRAM_USERNAME}&text=${encoded}`;
    default:
      return SALON_PHONE_TEL;
  }
}
